import React from 'react';
import PropTypes from 'prop-types';

/**
 * Small always-visible tag in the bottom-right corner naming the deployed build, so testers and
 * support can tell which version they're looking at without opening the menu drawer.
 *
 * `version` comes from REACT_APP_BUILD_ID, set by ci-develop.yml / ci-release.yml from
 * `git describe --tags --always`: "v1.7.0" on a release, "v1.7.0-3-g618a7ac" on dev (three
 * commits past v1.7.0), or just the commit before the first release tag exists.
 * Non-production builds are labelled so a dev screen is never mistaken for prod.
 */
const VersionTag = ({ version, environment }) => (
  <div
    aria-label={`Version ${version}${environment ? `, ${environment}` : ''}`}
    style={{
      position: 'fixed',
      right: '8px',
      bottom: '8px',
      zIndex: 2600,
      padding: '2px 8px',
      borderRadius: '4px',
      background: 'rgba(0, 0, 0, 0.6)',
      color: '#fff',
      font: '11px/1.6 Consolas, Menlo, monospace',
      pointerEvents: 'none',
      userSelect: 'none'
    }}
  >
    {environment ? `${environment} · ` : ''}
    {version}
  </div>
);

VersionTag.propTypes = {
  version: PropTypes.string.isRequired,
  environment: PropTypes.string
};

VersionTag.defaultProps = {
  environment: ''
};

export default VersionTag;
